<nz-table nzBordered [nzData]="products" nzFrontPagination="false" (nzQueryParams)="onQueryParamsChange($event)"
  [nzLoading]="isLoading" [nzScroll]="{ y: (containerHeight - 600) + 'px', x: '600px' }" class="products-table">
  <thead>
    <tr>

      <th id="th-selectable" [nzWidth]="'50px'" [nzLeft]="true" *ngIf="selectable" [nzSelections]="listOfSelection"
        [(nzChecked)]="checked" [nzIndeterminate]="indeterminate">
        <!-- <nz-select [(ngModel)]="selecttionType" (ngModelChange)="onAllSelectionChange()" [nzSize]="'small'"
          *ngIf="singleSelection === false" [nzDropdownStyle]="{ width: '150px' }">
          <nz-option *ngIf="!disableSelectAll" [nzLabel]="'All Products'" [nzValue]="0"
            class=
            "small-option"></nz-option>
          <nz-option [nzLabel]="'All in page'" [nzValue]="1" class="small-option"></nz-option>
          <nz-option [nzLabel]="'Deselect'" [nzValue]="2" class="small-option"></nz-option>
        </nz-select> -->
      </th>

      <!-- <th [nzLeft]="true" id="th-product-details" [nzWidth]="'350px'">
        {{'Product Details' | locale}}
      </th> -->
      <th [id]="'th-custom-column-' + column.name" *ngFor="let column of listColumns;let i = index" [nzSortFn]="true"
        [nzColumnKey]="column.name" [nzWidth]="column | columnWidth">
        {{ column.label }}


      </th>
      <th [id]="'th-actions'" [nzRight]="true" [nzWidth]="'50px'" *ngIf="withActions"
        style="background: #fafafa !important;">


      </th>

    </tr>
    <!-- Filters -->
    <tr *ngIf="withHeaderFilters === true">
      <th id="th-0-selectable" [nzLeft]="true" *ngIf="selectable">


      </th>
      <!-- <th id="th-0-product-details" [nzLeft]="true"></th> -->
      <th [id]="'th-0-custom-column-' + column.name" *ngFor="let column of listColumns">
        <app-filter-base [filterId]="column.name" [withLabels]="false" [column]="column" [inputFilters]="savedFilters!"
          (FilterValueChanged)="filterChange(column,$event)"></app-filter-base>
      </th>
      <th [id]="'th-0-actions'" [nzRight]="true" nzWidth="150px" *ngIf="withActions"
        style="background: #fafafa !important;">
        <!-- <ng-container *isAuthorized="'Admin,Editor'">
          <button nz-button nzType="primary" style="padding: 4px 15px; width: inherit" class="border-radius"
            *ngIf="selectedIds.size > 0" (click)="showSyncModal()">
            <i class="fal fa-exchange-alt"></i>
          </button>
        </ng-container> -->

      </th>
    </tr>
  </thead>
  <tbody class="products-table-body">
    <tr *ngFor="let product of products" style="position: relative">
      <td id="td-selectable" [nzLeft]="true" *ngIf="selectable && singleSelection === false"
        [nzChecked]="selectedIds.has(product.id)" (nzCheckedChange)="onItemChecked(product, $event)" [nzLeft]="true">
      </td>

      <!-- <td id="td-product-details" [nzLeft]="true">
        {{product.name}}
        <br />
        <nz-space>
          <span *nzSpaceItem>
            <span *ngIf="product?.hasVariants" nz-tooltip nzTooltipTitle="This product has variants"><i
                class="fal fa-link"></i></span>
            <span *ngIf="product?.hasInheritance" nz-tooltip
              nzTooltipTitle="This product inherits values from another product"><i
                class="fal fa-sort-shapes-down-alt"></i></span>
          </span>
          <span *nzSpaceItem>
            {{product.sku}}
          </span>
        </nz-space>
        <div style="width: 50%;" *ngIf="product.completionSet !== ''">
          <nz-progress [nzPercent]="product.completion?.averagePercentage" nzSize="small"></nz-progress>
        </div>
      </td> -->

      <td *ngIf="selectable && singleSelection === true">
        <a (click)="onSingleSelection(product)">
          <i class="fas fa-arrow-alt-circle-right"></i>
        </a>
      </td>

      <td *ngFor="let column of listColumns; let i = index">

        <nz-space>
          <span *nzSpaceItem>
            <span *ngIf="i === 0 && product?.hasVariants" nz-tooltip
              nzTooltipTitle="{{'This product has variants'  | translate}}"><i class="fal fa-link"></i></span>
            <span *ngIf="i === 0 && product?.hasInheritance" nz-tooltip
              nzTooltipTitle="{{'This product inherits values from another product'  | translate}}"><i
                class="fal fa-sort-shapes-down-alt"></i></span>
          </span>
          <span *nzSpaceItem>
            <span *ngIf="column.type === 'product'">
              <!-- <ng-container *ngIf="column.filterType !== 2">
                {{ product[column.name] }}
              </ng-container> -->

              <ng-container *ngIf="column.filterType !== 2">
                <ng-container *ngIf="column.filterType === 1; else normalText">
                  <a nz-button nzType="text" [routerLink]="['/product', product.id]"
                    [queryParams]="{ activePage: 'categories' }" style="background: none;">

                    <ng-container *ngIf="column.label === 'Description' || column.label ==='Sku' ; else plainText">
                    
                      <span  
                      class="truncate-text"
                      [ngClass]="{
                        'description-width': column.label === 'Description',
                        'sku-width': column.label === 'Sku'
                      }"
                      nz-tooltip [nzTooltipTitle]="product[column.name]"
                      > {{ product[column.name]  }}</span>
                    </ng-container>
                    <ng-template #plainText>
                      {{ product[column.name] }}
                    </ng-template>
                  </a>
                </ng-container>
                <ng-template #normalText>
                  {{ product[column.name] }}
                </ng-template>
              </ng-container>


              <ng-container *ngIf="column.filterType === 2">
                <!-- {{ product[column.name] | date : "short" }} -->
                   {{ product[column.name] | date: "dd/MM/yy, h:mm a" }}
              </ng-container>
            </span>
            <span *ngIf="column.type === 'attribute'">
              <span *ngIf="[6, 7].includes(column.filterType!)">
                {{
                product.attributes
                | DpdAttributeValue
                : column.name
                : commonService.dropDownMetaData
                }}
              </span>
              <span *ngIf="![6, 7, 9].includes(column.filterType!)" [innerHTML]="
                  product.attributes
                    | ValueFromArray
                      : 'value'
                      : { name: 'id', value: column.name.split('#')[0] }
                ">
              </span>


              <span *ngIf="column.filterType === 9">
                <ng-container *ngIf="(product.attributes
                | ValueFromArray : 'value' : { name: 'id', value: column.name.split('#')[0] }
                | async) as imageUrl">
                  <img *ngIf="imageUrl && isString(imageUrl); else defaultImage" [src]="imageUrl | safeHtml:'url'"
                    width="75" height="75" loading="lazy" alt="failed to load media" />
                </ng-container>

                <ng-template #defaultImage>
                  <img src="../../../../assets/defaultProductImage.png" width="75" height="75" loading="lazy"
                    alt="default image" />
                </ng-template>

                <!-- <img loading="lazy" [src]="
                    mediaUrl +
                    (product.attributes
                      | ValueFromArray
                        : 'value'
                        : { name: 'id', value: column.name.split('#')[0] }
                      | safeHtml : 'encodeUrl') +
                    '&width=100'
                  " alt="failed to load media" width="75" height="75" onerror="this.remove();" /> -->

              </span>




            </span>
          </span>
          <span *ngIf="column.type === 'completion'">
            <span *ngIf="product.completionSet !== ''">
              {{ product.completionSet }} :
              {{ product.completion?.averagePercentage }}%
            </span>
          </span>
          <span *ngIf="column.name === 'categories'" [innerHTML]="product.categoriesPathes">
          </span>
          <!-- </span> -->
        </nz-space>
      </td>

      <td *ngIf="withActions">

        <ng-container *isAuthorized="'Admin,Editor'">
          <button nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'bottomCenter'" style="border:none;font-size: 20px;background: none;
            display: flex;  align-items: center;
            justify-content: center;
            width:40px;
            align-items: center;">


            <span nz-icon nzType="more" nzTheme="outline"></span>
          </button>

          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu class="dropdown-menu">
              <!-- <li nz-menu-item>
                <a nz-button nzType="text" routerLink="../{{ product.id }}" 
                [queryParams]="{ activePage: 'categories' }">
                  <span nz-icon nzType="edit" nzTheme="outline"></span> Edit
                </a>
              </li> -->

              <li nz-menu-item>
                <a nz-button nzType="text" [routerLink]="['/product', product.id]"
                  [queryParams]="{ activePage: 'categories' }" style="background: none;">
                  <span nz-icon nzType="edit" nzTheme="outline"></span> {{'Edit' | translate}}
                </a>
              </li>

              <li nz-menu-item>
                <a nz-button nzType="text" [routerLink]="['../create']" [queryParams]="{ duplicateId: product.id }"
                  routerLinkActive="router-link-active" style="background: none;">
                  <span nz-icon nzType="copy" style="margin-right: 0;" nzTheme="outline"></span> {{'Copy' | translate}}
                </a>
              </li>
              <li nz-menu-item>
                <a nz-button nzType="text" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'Are you sure delete this product?' | locale | translate"
                  (nzOnConfirm)="deleteProduct(product.id)" style="background: none;">
                  <span nz-icon nzType="delete" nzTheme="outline"></span> {{'Delete'| translate}}
                </a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </ng-container>
        <ng-container *isAuthorized="'Viewer'">
          <a nz-button nzType="text" [routerLink]="['../', product.id, { mode: 'reader' }]">
            <span nz-icon nzType="info-circle" nzTheme="outline"></span>
          </a>
        </ng-container>
      </td>
    </tr>
  </tbody>
</nz-table>
<div class="container">

  <div class="selected-count">
    {{ getSelectedCount() > 0 ? ('Selected Products: ' | translate) + getSelectedCount() : ('No products selected' |
    translate) }}
  </div>

  <div class="pagination-container">
    <nz-pagination [nzPageIndex]="payload.PageIndex + 1" (nzPageIndexChange)="onPageIndexChange($event)"
      [nzTotal]="totalCount" nzShowSizeChanger [nzPageSizeOptions]="[10, 25, 50, 100, 200]"
      [(nzPageSize)]="payload.PageSize" (nzPageSizeChange)="this.getProducts.emit(this.payload)"></nz-pagination>
  </div>

</div>

<nz-modal [nzVisible]="showSync" [nzTitle]="'Choose channels to sync with' | locale" [nzClassName]="'channels-modal'"
  (nzOnCancel)="cancelSync()">
  <div *nzModalContent>
    <app-product-integrations (selectionChanged)="selectedChannelsChanged($event)"></app-product-integrations>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="submitChannels()">
      {{'Submit' | translate}}
    </button>
    <button nz-button (click)="cancelSync()">{{'Cancel'| translate }}</button>
  </div>
</nz-modal>